function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './moduleHeader.scss';
import template from './moduleHeader.html';

export var ModuleHeaderComponent = {
  template: template,
  styles: styles,
  bindings: {},
  controller: /*#__PURE__*/function () {ModuleHeaderComponentController.$inject = ["$scope", "$http", "gplansConf"];
    function ModuleHeaderComponentController($scope, $http, gplansConf) {
      "ngInject";_classCallCheck(this, ModuleHeaderComponentController);
      console.log(this);
      this.$scope = $scope;
      this.$http = $http;
      this.gplansConf = gplansConf;
      this.activeModule = null;
    }_createClass(ModuleHeaderComponentController, [{ key: "$onInit", value: function $onInit()

      {
        this.getActiveModule();
      } }, { key: "getActiveModule", value: function getActiveModule()

      {var _this = this;
        this.$http.get(this.gplansConf.API_URL + '/api/v1/modules/active/').then(function (res) {
          console.log(' -> Module Active', res);
          if (res.data) {
            _this.activeModule = res.data;
          }
        });
      } }]);return ModuleHeaderComponentController;}() };